export default __webpack_public_path__ + "static/media/CV_carrier.943db733.png";